// src/ramda-adjunct/hasPath.ts
import isNil from "ramda/src/isNil";
import _path from "ramda/src/path";
function hasPath(path, obj) {
  return arguments.length === 2 ? !isNil(_path(path, obj || {})) : (_obj) => !isNil(_path(path, _obj));
}
var hasPath_default = hasPath;

export {
  hasPath_default
};
//# sourceMappingURL=chunk-OZ3GY3JP.mjs.map